var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('master-main',{ref:"masterMain",attrs:{"addProperties":{
      isWizard: false,
    },"exportProperties":{
      pdf: {
        filename: `${_vm.$t(
          'inventory.toxicity_classification'
        )}_${_vm.dateToday}.pdf`,
        route: `${_vm.getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${_vm.$t(
          'inventory.toxicity_classification'
        )}_${_vm.dateToday}.xlsx`,
        route: `${_vm.getModuleRoute}/excel`,
      },
    },"dataBadges":[
      {
        columnLabel: _vm.$t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 180,
      },
    ],"route":_vm.getModuleRoute,"showProperties":_vm.showProperties,"tableProperties":_vm.tableProperties},on:{"closeModal":_vm.handleCloseModal,"openModal":_vm.handleOpenModal,"refresh":_vm.refresh,"showHideLoading":_vm.showHideLoading,"showNotification":_vm.notifyVue}},[_c('template',{slot:"dialogForm"},[(_vm.renderComponent)?_c('edit-or-create',{ref:"editCreate",attrs:{"syncDialog":_vm.modals},on:{"addEdit":_vm.addEdit,"closeModal":_vm.handleCloseModal,"showHideLoading":_vm.showHideLoading,"showNotification":_vm.notifyVue}}):_vm._e()],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }